// src/components/OffersDetails.js

import React from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Typography,
    Box,
    IconButton,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    useTheme,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import Heading from '../common/Heading/Heading';



const OffersDetails = ({ open, onClose, offer }) => {
    const theme = useTheme()
    if (!offer) return null;

    return (
        <Dialog open={open} maxWidth="md" fullWidth>
            <DialogTitle>
                <div className="flex justify-between items-center">
                    <Heading title={"Product Details"} />
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <Divider sx={{ mt: 1 }} />
            </DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 2 }}>
                    <TableContainer >
                        <Table sx={{ border: "1px solid #e1e1e1" }}>
                            <TableBody>
                                <TableRow>
                                    <TableCell><Typography variant="h4" sx={{ color: "black", width: "140px" }}>Photo</Typography></TableCell>
                                    <TableCell>
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                            <Typography variant="body2">
                                                <img src={offer.photo} alt={offer.title} style={{ maxWidth: '100%', maxHeight: '100%' }} />
                                            </Typography>
                                        </div>
                                    </TableCell>

                                </TableRow>
                                <TableRow>
                                    <TableCell><Typography variant="h4" sx={{ color: "black", width: "140px" }}>Title</Typography></TableCell>
                                    <TableCell><Typography variant="body2">{offer.title}</Typography></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><Typography variant="h4" sx={{ color: "black" }}>Description</Typography></TableCell>
                                    <TableCell><Typography variant="body2">{offer.description}</Typography></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><Typography variant="h4" sx={{ color: "black" }}>Category</Typography></TableCell>
                                    <TableCell><Typography variant="body2">{offer.category}</Typography></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><Typography variant="h4" sx={{ color: "black" }}>Original Price</Typography></TableCell>
                                    <TableCell><Typography variant="body2">{offer.originalPrice} </Typography></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><Typography variant="h4" sx={{ color: "black" }}>Discount Price</Typography></TableCell>
                                    <TableCell><Typography variant="body2">{offer.discountPrice} </Typography></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><Typography variant="h4" sx={{ color: "black" }}>Percentage Off</Typography></TableCell>
                                    <TableCell><Typography variant="body2">{offer.percentageOff}</Typography></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><Typography variant="h4" sx={{ color: "black" }}>Merchant</Typography></TableCell>
                                    <TableCell><Typography variant="body2">{offer.merchant}</Typography></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><Typography variant="h4" sx={{ color: "black" }}>Hot Deals Ranking</Typography></TableCell>
                                    <TableCell><Typography variant="body2">{offer.hotDealsRanking}</Typography></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><Typography variant="h4" sx={{ color: "black" }}>New Deals Ranking</Typography></TableCell>
                                    <TableCell><Typography variant="body2">{offer.newDealsRanking}</Typography></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><Typography variant="h4" sx={{ color: "black" }}>Created At</Typography></TableCell>
                                    <TableCell><Typography variant="body2">{offer.createdAt}</Typography></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><Typography variant="h4" sx={{ color: "black" }}>Updated At</Typography></TableCell>
                                    <TableCell><Typography variant="body2">{offer.updatedAt}</Typography></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><Typography variant="h4" sx={{ color: "black" }}>Expiry status</Typography></TableCell>
                                    <TableCell><Typography variant="body2">{offer.is_expired?`Expired`:`Not Expired`}</Typography></TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </DialogContent>
            {/* <DialogActions>
                <div className="w-fit mb-2 px-4">
                    <Button
                        onClick={onClose}
                        variant="contained"
                        color="primary"
                        sx={{ py: 1, background: theme.palette.primary[800], color: "white" }}
                    >
                        Close
                    </Button>

                </div>
            </DialogActions> */}
        </Dialog>
    );
};

export default OffersDetails;
